/* Product page: required bundle (1/2/3) + optional add-ons in ONE cart call, variant (color) updates,
   gallery thumbnails and the sticky add-to-cart bar. Depends on theme.js (window.themeCart, theme.money). */
(function () {
  'use strict';
  if (window.__croProduct) { return; }
  window.__croProduct = true;

  var D = document;
  var T = window.theme || { routes: {}, strings: {} };
  var S = T.strings || {};
  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }
  function money(c) { return T.money ? T.money(c) : '$' + ((Number(c) || 0) / 100).toFixed(2); }
  /* like Liquid's money_without_trailing_zeros: $20.00 -> $20, $10.92 stays */
  function moneyShort(c) { var m = money(c); return Math.round(Number(c) || 0) % 100 === 0 ? m.replace(/[.,]00(?!\d)/, '') : m; }
  /* cents off per unit = floor(unit x pct / 100), like Shopify's checkout; via integer basis points (5.46% -> 546 bp)
     so it is identical to the Liquid in main-product / product-cta-repeat */
  function unitOff(u, pct) { return Math.floor(u * Math.round((parseFloat(pct) || 0) * 100) / 10000); }
  function cart() { return window.themeCart; }

  /* runs on load and again when the theme editor re-renders the product section */
  function init() {
    var form = $('[data-product-form]');
    if (!form || form.__croBound) { return; }
    form.__croBound = true;

    var productId = String(form.getAttribute('data-product-id') || '');
    var idInput = $('input[name="id"]', form);
    var bundles = $('#bundles', form);
    var radios = $$('input[name="bundle_qty"]', form);
    var unit = bundles ? parseInt(bundles.getAttribute('data-unit'), 10) || 0 : 0;
    var available = form.getAttribute('data-available') !== 'false';
    var prot = $('#prot', form);
    var prio = $('#prio', form);
    var addons = [
      { el: prot, id: 'data-prot-id', price: 'data-prot-price' },
      { el: prio, id: 'data-prio-id', price: 'data-prio-price' }
    ].filter(function (a) { return a.el; });
    var stickyEl = $('[data-sticky-price]');
    var stickyLab = $('[data-sticky-label]');
    var productName = stickyLab ? stickyLab.getAttribute('data-name') || '' : '';
    var variantName = stickyLab ? stickyLab.getAttribute('data-variant') || '' : '';
    var msg = $('[data-msg]', form);
    var priceEl = $('[data-price]');
    var compareEl = $('[data-compare]');
    /* the amount sits in its own span so the visually-hidden "Regular price" label survives updates */
    var compareVal = compareEl ? $('[data-compare-val]', compareEl) || compareEl : null;
    var badgeEl = $('[data-save-badge]');
    var mainImg = $('#main-image');
    var busy = false;
    /* compare-at price (cents) of the current variant, from the picker's variant JSON */
    var cmpUnit = 0;
    try {
      var vj = $('[data-variant-json]', form);
      (vj ? JSON.parse(vj.textContent) : []).forEach(function (v) {
        if (idInput && String(v.id) === idInput.value) { cmpUnit = parseInt(v.compare_at_price, 10) || 0; }
      });
    } catch (e0) { cmpUnit = 0; }

    function selected() { return radios.filter(function (r) { return r.checked; })[0]; }
    /* a bundle is REQUIRED: if none is selected (should be impossible), fall back to Buy 1 */
    function ensureBundle() {
      var sel = selected();
      if (sel || !radios.length) { return sel; }
      var pick = radios.filter(function (r) { return r.value === '1'; })[0] || radios[0];
      if (pick) { pick.checked = true; }
      return pick;
    }
    function totalFor(r) {
      var q = parseInt(r.getAttribute('data-qty-opt'), 10) || 1;
      var ref = parseFloat(r.getAttribute('data-ref')) || 0;
      var total = q * (unit - unitOff(unit, r.getAttribute('data-discount')));
      /* strike = buying singles (unit x qty; Buy 1 uses the compare-at price when higher),
         or the former price (theme setting): total / (1 - ref%), floored like the Liquid */
      if (!(ref > 0 && ref < 100)) { ref = 0; }
      var strike = ref ? Math.floor(total * 100 / (100 - ref)) : (q === 1 && cmpUnit > unit ? cmpUnit : unit * q);
      return { qty: q, ref: ref, strike: strike, total: total };
    }
    /* "Save 12%" for a former-price ref, otherwise the amount: "Save $20" */
    function saveText(t, el) {
      if (t.ref) { return (el.getAttribute('data-template') || S.savePct || 'Save [pct]%').replace('[pct]', t.ref); }
      return (el.getAttribute('data-template-amount') || 'Save [amount]').replace('[amount]', moneyShort(t.strike - t.total));
    }

    function update() {
      var sel = ensureBundle();
      addons.forEach(function (a) {
        var lab = a.el.closest ? a.el.closest('label') : null;
        if (lab) { lab.classList.toggle('on', a.el.checked); }
      });
      radios.forEach(function (r) {
        var label = r.closest ? r.closest('label') : null;
        if (!label) { return; }
        label.classList.toggle('sel', r === sel);
        var t = totalFor(r);
        var tEl = $('[data-card-total]', label);
        var sEl = $('[data-card-strike]', label);
        var pEl = $('[data-card-save]', label);
        if (tEl) { tEl.textContent = money(t.total); }
        if (sEl) { sEl.hidden = !(t.strike > t.total); sEl.textContent = money(t.strike); }
        if (pEl && badgeEl) {
          pEl.hidden = !(t.strike > t.total);
          if (t.strike > t.total) { pEl.textContent = saveText(t, badgeEl); }
        }
      });
      if (!sel) { return; }
      /* top price = selected bundle total, struck exactly like its card (former price, compare-at for Buy 1, or unit x qty) */
      var tt = totalFor(sel);
      var was = tt.strike;
      if (priceEl) { priceEl.textContent = money(tt.total); }
      if (compareEl) {
        compareEl.hidden = !(was > tt.total);
        if (was > tt.total) { compareVal.textContent = money(was); }
      }
      if (badgeEl) {
        badgeEl.hidden = !(was > tt.total);
        if (was > tt.total) { badgeEl.textContent = saveText(tt, badgeEl); }
      }
      var extra = 0;
      addons.forEach(function (a) { if (a.el.checked) { extra += parseInt(a.el.getAttribute(a.price), 10) || 0; } });
      if (stickyEl) { stickyEl.textContent = money(totalFor(sel).total + extra); }
      if (stickyLab) { stickyLab.textContent = totalFor(sel).qty + ' × ' + (variantName || productName); }
    }

    /* "Prefer just one part?" links: point each resolved part at its variant in the color picked on the set
       (data-part-variants = "blue=123|red=456|", printed by Liquid; fallback links have no map and stay as they are) */
    function updateParts(v) {
      var vals = ((v && v.options) || []).map(function (o) { return String(o).toLowerCase().trim(); });
      $$('[data-part-variants]').forEach(function (a) {
        var base = a.getAttribute('data-part-base');
        if (!base) { return; }
        var hit = '';
        (a.getAttribute('data-part-variants') || '').split('|').forEach(function (pair) {
          var i = pair.lastIndexOf('=');
          if (hit || i < 1) { return; }
          if (vals.indexOf(pair.slice(0, i)) !== -1) { hit = pair.slice(i + 1); }
        });
        if (hit) { a.setAttribute('href', base + '?variant=' + hit); }
      });
    }

    function setButtons() {
      $$('[data-add-btn]').forEach(function (b) {
        b.disabled = busy || !available;
        /* data-no-ship = "Not available in <country>" when the product doesn't ship there (snippets/no-ship.liquid) */
        b.textContent = !available ? (form.getAttribute('data-no-ship') || S.soldOut || 'Sold out') : (busy ? (S.adding || 'Adding…') : (S.addToCart || 'Add to cart'));
        b.setAttribute('aria-busy', busy ? 'true' : 'false');
      });
      if (bundles) { bundles.classList.toggle('is-soldout', !available); }
    }

    function say(text, isError) {
      if (!msg) { return; }
      msg.className = 'msg' + (isError ? ' err' : '');
      msg.textContent = text;
    }

    /* ---------- gallery ---------- */
    function showImage(src, srcset, alt, imageId) {
      if (mainImg && src) {
        if (srcset) { mainImg.setAttribute('srcset', srcset); } else { mainImg.removeAttribute('srcset'); }
        mainImg.src = src;
        if (alt) { mainImg.alt = alt; }
      }
      $$('[data-thumb]').forEach(function (t) {
        var on = imageId != null && String(t.getAttribute('data-image-id')) === String(imageId);
        t.classList.toggle('on', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        showImage(t.getAttribute('data-src'), t.getAttribute('data-srcset'), t.getAttribute('data-alt'), t.getAttribute('data-image-id'));
      });
    });

    /* ---------- variant (color) change from the picker ---------- */
    D.addEventListener('variant:change', function (e) {
      var d = e.detail || {};
      var v = d.variant;
      /* a form replaced by the theme editor is ignored: the new init() owns the new one */
      if (!v || String(d.productId) !== productId || !D.documentElement.contains(form)) { return; }
      if (idInput) { idInput.value = v.id; }
      unit = parseInt(v.price, 10) || 0;
      if (bundles) { bundles.setAttribute('data-unit', unit); }
      available = !!v.available;
      variantName = v.title && v.title !== 'Default Title' ? v.title : '';
      if (stickyLab) { stickyLab.setAttribute('data-variant', variantName); }
      cmpUnit = parseInt(v.compare_at_price, 10) || 0;
      /* price, compare-at and badge are redrawn by update() below */
      if (v.featured_image) {
        showImage(v.featured_image.src, v.featured_image.srcset, v.featured_image.alt, v.image_id);
      }
      say('', false);
      update();
      setButtons();
      updateParts(v);
    });

    radios.forEach(function (r) { r.addEventListener('change', update); });
    addons.forEach(function (a) { a.el.addEventListener('change', update); });
    update();
    if (!available) { setButtons(); }

    /* ---------- add to cart: main variant x bundle qty + checked add-ons ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy || !available) { return; }
      var tc = cart();
      var sel = ensureBundle();
      var mainId = idInput ? parseInt(idInput.value, 10) : 0;
      if (!sel || !mainId || !tc) { say(S.error || 'Error', true); return; }
      var items = [{ id: mainId, quantity: parseInt(sel.value, 10) || 1 }];
      addons.forEach(function (a) {
        var vid = parseInt(a.el.getAttribute(a.id), 10);
        if (a.el.checked && vid) { items.push({ id: vid, quantity: 1 }); }
      });
      var trigger = e.submitter || D.activeElement;
      busy = true;
      setButtons();
      say('', false);
      /* add-ons already in the cart are not re-sent (they would bump to qty 2 and need a cleanup) */
      tc.getCart()
        .then(function (c) {
          var inCart = c.items.map(function (i) { return i.variant_id; });
          return [items[0]].concat(items.slice(1).filter(function (it) { return inCart.indexOf(it.id) === -1; }));
        }, function () { return items; })
        .then(function (send) { return tc.post(T.routes.cartAdd, { items: send }); })
        .then(function () { return tc.refresh(); })
        /* the add already succeeded: a failed re-read must not report "could not add" (a retry would double the quantity) */
        .then(function () { return tc.getCart().catch(function () { return null; }); })
        .then(function (c) {
          if (c) { tc.applyCart(c); }
          busy = false;
          setButtons();
          /* the cart drawer (if present) takes over and opens; otherwise show the inline message */
          var evt = null;
          try { evt = new CustomEvent('cart:added', { cancelable: true, detail: { cart: c, trigger: trigger } }); } catch (e2) { evt = null; }
          if (evt && !D.dispatchEvent(evt)) { return; }
          say(S.added || 'Added to your cart', false);
        })
        .catch(function (err) {
          busy = false;
          setButtons();
          say((err && typeof err.description === 'string' && err.description) || S.error || 'Error', true);
        });
    });

    /* ---------- sticky bar: visible once the main button scrolled out of view (above the viewport) ---------- */
    var st = $('[data-sticky]');
    var mainBtn = $('[data-add-btn]', form);
    if (st && mainBtn) {
      D.documentElement.classList.add('js-sticky');
      var queued = false;
      var stickyCheck = function () {
        queued = false;
        if (!D.documentElement.contains(mainBtn)) { return; }
        st.classList.toggle('is-shown', mainBtn.getBoundingClientRect().bottom < 0);
      };
      if ('IntersectionObserver' in window) { new IntersectionObserver(stickyCheck).observe(mainBtn); }
      /* the observer misses jumps that skip over the button (e.g. straight back to the top),
         so a passive, rAF-throttled scroll check re-reads its position as well */
      window.addEventListener('scroll', function () {
        if (queued) { return; }
        queued = true;
        if (window.requestAnimationFrame) { window.requestAnimationFrame(stickyCheck); } else { setTimeout(stickyCheck, 16); }
      }, { passive: true });
      stickyCheck();
    }
  }
  init();
  D.addEventListener('shopify:section:load', init);
})();
